angular.module('public.security-manager.employee').component('gccsEmployeeProfileApproveClientTitle', {
  template: require('./template.pug'),
  transclude: true,
  controller: 'EmployeeClientApproveClientTitleController',
  bindings: {
    title: '@',
    count: '<'
  }
});
